"use strict";
// Ported from https://github.com/lemire/JavaFastPFOR/blob/master/src/main/java/me/lemire/integercompression/IntWrapper.java
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntWrapper = void 0;
class IntWrapper {
    constructor(v) {
        this.v = v;
        this.value = v;
    }
    get() {
        return this.value;
    }
    set(v) {
        this.value = v;
    }
    increment() {
        return this.value++;
    }
    add(v) {
        this.value += v;
    }
}
exports.IntWrapper = IntWrapper;
//# sourceMappingURL=IntWrapper.js.map